export const emojis: Record<string, string> = {
  fst: "fst_logo.png",
};

export const emojiRegex = /:([a-zA-Z0-9_+-]+):/g;
